// import { csrfFetch } from "./csrf"; // No longer needed for frontend-only mode
//create, read, update

//------------------------------create payments---------------------------------
const ADD_PAYMENT = "payments/ADD"
export const addPayment = (payment) => ({
  type: ADD_PAYMENT,
  payment
});

export const postPayment = (payment) => async(dispatch) => {
  const { userService } = await import('../utils/userService');
  
  const newTransaction = userService.createTransaction({
    ...payment,
    status: 'completed',
    privacy: 'friends'
  });
  
  // Transform to match expected format
  const users = userService.getAllUsers();
  const sender = users.find(u => u.id === newTransaction.sender_id);
  const receiver = users.find(u => u.id === newTransaction.receiver_id);
  
  const new_payment = {
    id: newTransaction.id,
    amount: newTransaction.amount,
    note: newTransaction.note,
    title: newTransaction.note,
    sender_id: newTransaction.sender_id,
    receiver_id: newTransaction.receiver_id,
    username: sender?.username || 'unknown',
    recipient: receiver?.username || 'unknown',
    sender_name: sender?.name || 'Unknown User',
    receiver_name: receiver?.name || 'Unknown User',
    type: newTransaction.type,
    created_at: newTransaction.created_at,
    comments: { comments: [] },
    likes: { likes: [] }
  };

  dispatch(addPayment(new_payment));
};

//------------------------------load payments---------------------------------
const LOADALL_PAYMENTS = "payments/LOADALL"
export const loadPayments = payments => ({
    type: LOADALL_PAYMENTS,
    payments
});

export const getAllPayments = () => async (dispatch) => {
  const { userService } = await import('../utils/userService');
  
  const transactions = userService.getAllTransactions();
  const users = userService.getAllUsers();
  
  // Transform transactions to match expected format
  const payments = transactions.map(transaction => {
    const sender = users.find(u => u.id === transaction.sender_id);
    const receiver = users.find(u => u.id === transaction.receiver_id);
    
    return {
      id: transaction.id,
      amount: transaction.amount,
      note: transaction.note,
      title: transaction.note,
      sender_id: transaction.sender_id,
      receiver_id: transaction.receiver_id,
      user_id: transaction.sender_id,
      recipient_id: transaction.receiver_id,
      username: sender?.username || 'unknown',
      recipient: receiver?.username || 'unknown',
      sender_name: sender?.name || 'Unknown User',
      receiver_name: receiver?.name || 'Unknown User',
      sender_picture: sender?.profile_picture,
      receiver_picture: receiver?.profile_picture,
      type: transaction.type,
      status: transaction.status,
      privacy: transaction.privacy,
      created_at: transaction.created_at,
      comments: {
        comments: transaction.comments.map(comment => ({
          ...comment,
          username: users.find(u => u.id === comment.user_id)?.username || 'unknown'
        }))
      },
      likes: {
        likes: transaction.likes.map(userId => ({
          id: userId,
          payment_id: transaction.id,
          user_id: userId,
          username: users.find(u => u.id === userId)?.username || 'unknown'
        }))
      }
    };
  });
  
  dispatch(loadPayments({ payments }));
}
//------------------------------get one payments---------------------------------
const LOADONE_PAYMENT = "payments/LAODONE"
export const loadOnePayment = payment => ({
  type: LOADONE_PAYMENT,
  payment
});

export const getOnePayment = paymentId => async(dispatch) => {
  // For frontend-only demo, return mock payment data
  const mockPayment = {
    id: paymentId,
    amount: 25.50,
    note: "Demo payment transaction",
    user_id: 1,
    recipient_id: 2,
    username: "demo_user",
    recipient: "alice_smith",
    created_at: new Date().toISOString()
  };
  dispatch(loadOnePayment(mockPayment));
}

//------------------------------payments reducer---------------------------------
const paymentReducer = (state ={}, action) => {
let newState = {...state};

  switch(action.type) {
    case LOADALL_PAYMENTS:
      if (action.payments) {
        action.payments.payments.forEach(
          (payment) => (newState[payment.id] = payment)
        )
      }else {
        newState ={}
      }
      return newState;
    case LOADONE_PAYMENT:
      newState[action.payment.id] = action.payment;

      return newState
    case ADD_PAYMENT:{
      newState[action.payment.id] = action.payment;
      return newState;
    }
    default:
      return state;
  }
}

export default paymentReducer;
